import { useQuery, UseQueryResult } from 'react-query';
import { AttendedTotalAmount, UrlParams } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams } from 'utils/functions';

interface IUseTotalAttended {
  athlete?: string;
  events?: string[];
  startDateRange?: string;
  endDateRange?: string;
  enabled?: boolean;
  type?: 'past' | 'upcoming';
}

function useTotalAttended({
  athlete,
  events,
  startDateRange,
  endDateRange,
  enabled = true,
  type,
}: IUseTotalAttended): UseQueryResult<{
  data: AttendedTotalAmount;
}> {
  const params: UrlParams = {};

  if (athlete) {
    params.athlete = athlete;
  }
  if (events && events.length > 0) {
    params.events = events.join(',');
  }
  if (startDateRange !== undefined) {
    params.start_date_range = startDateRange;
  }
  if (endDateRange !== undefined) {
    params.end_date_range = endDateRange;
  }
  if (type !== undefined) {
    params.type = type;
  }
  params.is_checked_in = 'True';

  return useQuery(
    ['totalAttended', athlete, events, startDateRange, endDateRange, enabled, type],
    () => client.get(`athlete-events/total-attended?${encodeUrlParams(params)}`),
    {
      enabled,
    },
  );
}

export default useTotalAttended;
